import { memo } from 'react';
import { strategyOptionsMapper, useOmakasePlanLogicSettings } from 'shared-modules/services/hooks/omakasePlanLogic';
import PriceChart from './PriceChart';
import OrderSettingTable from './OrderSettingTable/OrderSettingTable';
import styles from './logicSetting.module.scss';

const LogicSetting = () => {
  const { selectedStrategy, strategyOptions, autoTradeSettingsData, helpers } = useOmakasePlanLogicSettings({
    mapper: strategyOptionsMapper.toIdValue,
  });

  if (!selectedStrategy) return null; // selectedStrategyはnullの可能性があるため、nullハンドリングが必要

  return (
    <div className={styles.logicSettingContainer}>
      <PriceChart selectedStrategy={selectedStrategy} strategyOptions={strategyOptions} />
      <hr className={styles.divider} />
      <OrderSettingTable
        autoTradeSettingsData={autoTradeSettingsData}
        selectedStrategy={selectedStrategy}
        helpers={helpers}
      />
    </div>
  );
};

export default memo(LogicSetting);
